import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import { request } from "../../../api/request.tsx";

interface NotificationData {
  topic: string;
  userId: string;
  title: string;
  titleEn: string;
  titleKo: string;
  description: string;
  descriptionEn: string;
  descriptionKo: string;
  data: {
    navigation: string;
    navigate: string;
  };
}

const NotificationPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const topicOptions = [
    {
      label: "Trung",
      topic: "USER65e815ab6543a915f4eec684",
      userId: "65e815ab6543a915f4eec684",
    },
    {
      label: "Toàn",
      topic: "USER690ef188936ba1001c906c41",
      userId: "690ef188936ba1001c906c41",
    },
    {
      label: "Xoan",
      topic: "USER65deeefbde35201fe4d5e329",
      userId: "65deeefbde35201fe4d5e329",
    },
    {
      label: "Bình",
      topic: "USER69f0279f496020001c36bda1",
      userId: "69f0279f496020001c36bda1",
    },
    {
      label: "Vân Anh",
      topic: "USER6896cdc97db3b7001c645cb7",
      userId: "6896cdc97db3b7001c645cb7",
    },
    { label: "GENERAL", topic: "GENERAL", userId: "all" },
  ];

  const routeOptions = [
    // Bottom tabs
    {
      label: "NOTIFICATION_SCREEN",
      key: "NotificationScreen",
      requiresId: false,
    }, //
    { label: "HOME_SCREEN", key: "HomeScreen", requiresId: false }, //
    { label: "FRAME_SCREEN", key: "FrameScreen", requiresId: false }, //
    { label: "HOME_SHOPPINGMALL", key: "HomeShopping", requiresId: false }, //
    { label: "ACCOUNT_SCREEN", key: "Account", requiresId: false }, //
    // Standalone screens
    { label: "DETAIL_EVENT", key: "DetailEvent:id", requiresId: false },
    // { label: 'IMAGE_SCREEN', key: 'ImageScreen', requiresId: false },
    // { label: 'DETAIL_COUPON', key: 'DetailCoupon', requiresId: false },
    { label: "FAQ_SCREEN", key: "FAQScreen", requiresId: false },
    { label: "USE_FRAME_SCREEN", key: "UseFrameScreen", requiresId: false },
    // { label: 'DETAIL_BRANCH', key: 'DetailBranch', requiresId: false },
    // { label: 'ACCOUNT_SCREEN', key: 'AccountScreen', requiresId: false },
    // { label: 'PROFILE_SCREEN', key: 'ProfileScreen', requiresId: false },
    // { label: 'SETTING_SCREEN', key: 'SettingScreen', requiresId: false },
    // { label: 'LANGUAGE_SCREEN', key: 'LanguageScreen', requiresId: false },
    { label: "SAVED_IMAGE_SCREEN", key: "SavedImageScreen", requiresId: false },
    { label: "PRINT_DRAFT_SCREEN", key: "PrintDraftScreen", requiresId: false },
    { label: "SAVED_SCREEN", key: "SavedScreen", requiresId: false },
    { label: "ACCUMULATE_POINTS", key: "AccumulatePoints", requiresId: false },
    // Routes requiring ID param
    { label: "DETAIL_FRAME", key: "DetailFrame/:id", requiresId: true }, //
    { label: "ORDER_DETAIL", key: "OrderDetail/:id", requiresId: true },
    { label: "DETAIL_EVENT", key: "DetailEvent/:id", requiresId: true },
  ];

  const [formData, setFormData] = useState<NotificationData>({
    topic: "",
    userId: "",
    title: "",
    titleEn: ".",
    titleKo: ".",
    description: "",
    descriptionEn: ".",
    descriptionKo: ".",
    data: {
      navigation: "",
      navigate: "",
    },
  });

  const handleInputChange = (field: string, value: any) => {
    if (field.includes(".")) {
      // Handle nested fields like data.navigation
      const [parent, child] = field.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...(prev[parent as keyof NotificationData] as any),
          [child]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.topic.trim()) {
      newErrors.topic = "Topic là bắt buộc";
    }
    if (!formData.userId.trim()) {
      newErrors.userId = "User ID là bắt buộc";
    }
    if (!formData.title.trim()) {
      newErrors.title = "Tiêu đề tiếng Việt là bắt buộc";
    }
    // if (!formData.titleEn.trim()) {
    //   newErrors.titleEn = 'Tiêu đề tiếng Anh là bắt buộc';
    // }
    // if (!formData.titleKo.trim()) {
    //   newErrors.titleKo = 'Tiêu đề tiếng Hàn là bắt buộc';
    // }
    if (!formData.description.trim()) {
      newErrors.description = "Mô tả tiếng Việt là bắt buộc";
    }
    // if (!formData.descriptionEn.trim()) {
    //   newErrors.descriptionEn = 'Mô tả tiếng Anh là bắt buộc';
    // }
    // if (!formData.descriptionKo.trim()) {
    //   newErrors.descriptionKo = 'Mô tả tiếng Hàn là bắt buộc';
    // }
    if (!formData.data.navigation.trim()) {
      newErrors["data.navigation"] = "Navigation là bắt buộc";
    }
    if (!formData.data.navigate.trim()) {
      newErrors["data.navigate"] = "Navigate là bắt buộc";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [selectedRouteKey, setSelectedRouteKey] =
    useState<string>("NotificationScreen");
  const [routeId, setRouteId] = useState<string>("");

  const buildDeepLink = (routeKey: string, id?: string) => {
    const path = routeKey.includes("/:id")
      ? routeKey.replace("/:id", id ? `/${id}` : "")
      : routeKey;
    const link = path ? `phototime://${path}` : "";
    return link;
  };

  const updateNavigationFields = (routeKey: string, id?: string) => {
    const option = routeOptions.find((r) => r.key === routeKey);
    if (!option) {
      handleInputChange("data.navigation", "");
      handleInputChange("data.navigate", "");
      return;
    }
    if (option.requiresId && !id) {
      handleInputChange("data.navigation", "");
      handleInputChange("data.navigate", "");
      return;
    }
    const link = buildDeepLink(routeKey, id);
    handleInputChange("data.navigation", link);
    handleInputChange("data.navigate", link);
  };

  useEffect(() => {
    if (!formData.data.navigation && !formData.data.navigate) {
      updateNavigationFields("NotificationScreen");
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      alert("Vui lòng kiểm tra và sửa các lỗi validation trước khi gửi");
      return;
    }

    setLoading(true);

    try {
      const response = await request("users/send-noti", formData, "POST");

      if (response?.status === true) {
        alert("Gửi thông báo thành công!");
        // Reset form
        setFormData({
          topic: "",
          userId: "",
          title: "",
          titleEn: ".",
          titleKo: ".",
          description: "",
          descriptionEn: ".",
          descriptionKo: ".",
          data: {
            navigation: "",
            navigate: "",
          },
        });
        setErrors({});
      } else {
        alert(response?.message || "Có lỗi xảy ra khi gửi thông báo");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-3 py-2 outline-none focus:border-pink-500 focus:ring-1 focus:ring-pink-500";
  const classLabel = "font-semibold text-[pink] mb-2 block";
  const classError = "text-red-500 text-sm mt-1";

  return (
    <div className="w-full max-w-4xl mx-auto p-6">
      <div className="text-2xl text-center text-[pink] font-bold mb-8">
        PHÁT THÔNG BÁO CHO NGƯỜI DÙNG
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Basic Information */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">
            Thông tin cơ bản
          </h3>

          <div>
            <label className={classLabel}>Topic *</label>
            <Select
              value={formData.topic}
              onChange={(value) => {
                const selectedOption = topicOptions.find(
                  (option) => option.topic === value
                );
                handleInputChange("topic", value);
                if (selectedOption) {
                  handleInputChange("userId", selectedOption.userId);
                }
              }}
              className={`w-full ${errors.topic ? "border-red-500" : ""}`}
              placeholder="Chọn topic"
              options={topicOptions.map((option) => ({
                value: option.topic,
                label: option.label,
              }))}
            />
            {errors.topic && <div className={classError}>{errors.topic}</div>}
          </div>

          {/* <div>
              <label className={classLabel}>User ID</label>
              <input
                readOnly
                type="text"
                value={formData.userId}
                className={`${classInput} bg-gray-100 text-gray-500 cursor-not-allowed`}
                placeholder="User ID sẽ tự động cập nhật khi chọn topic"
              />
            </div> */}
        </div>

        {/* Multi-language Titles */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">Tiêu đề</h3>

          <div className="space-y-4">
            <div>
              <label className={classLabel}>Tiếng Việt*</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => handleInputChange("title", e.target.value)}
                className={`${classInput} ${
                  errors.title ? "border-red-500" : ""
                }`}
                placeholder="Nhập tiêu đề tiếng Việt"
              />
              {errors.title && <div className={classError}>{errors.title}</div>}
            </div>

            {/* <div>
              <label className={classLabel}>English*</label>
              <input
                type="text"
                value={formData.titleEn}
                onChange={(e) => handleInputChange('titleEn', e.target.value)}
                className={`${classInput} ${errors.titleEn ? 'border-red-500' : ''}`}
                placeholder="Nhập tiêu đề tiếng Anh"
              />
              {errors.titleEn && <div className={classError}>{errors.titleEn}</div>}
            </div>

            <div>
              <label className={classLabel}>한국어*</label>
              <input
                type="text"
                value={formData.titleKo}
                onChange={(e) => handleInputChange('titleKo', e.target.value)}
                className={`${classInput} ${errors.titleKo ? 'border-red-500' : ''}`}
                placeholder="Nhập tiêu đề tiếng Hàn"
              />
              {errors.titleKo && <div className={classError}>{errors.titleKo}</div>}
            </div> */}
          </div>
        </div>

        {/* Multi-language Descriptions */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">Mô tả</h3>

          <div className="space-y-4">
            <div>
              <label className={classLabel}>Tiếng Việt*</label>
              <textarea
                value={formData.description}
                onChange={(e) =>
                  handleInputChange("description", e.target.value)
                }
                className={`${classInput} min-h-[100px] resize-y ${
                  errors.description ? "border-red-500" : ""
                }`}
                placeholder="Nhập mô tả tiếng Việt"
              />
              {errors.description && (
                <div className={classError}>{errors.description}</div>
              )}
            </div>

            {/* <div>
              <label className={classLabel}>English*</label>
              <textarea
                value={formData.descriptionEn}
                onChange={(e) => handleInputChange('descriptionEn', e.target.value)}
                className={`${classInput} min-h-[100px] resize-y ${errors.descriptionEn ? 'border-red-500' : ''}`}
                placeholder="Nhập mô tả tiếng Anh"
              />
              {errors.descriptionEn && <div className={classError}>{errors.descriptionEn}</div>}
            </div>

            <div>
              <label className={classLabel}>한국어*</label>
              <textarea
                value={formData.descriptionKo}
                onChange={(e) => handleInputChange('descriptionKo', e.target.value)}
                className={`${classInput} min-h-[100px] resize-y ${errors.descriptionKo ? 'border-red-500' : ''}`}
                placeholder="Nhập mô tả tiếng Hàn"
              />
              {errors.descriptionKo && <div className={classError}>{errors.descriptionKo}</div>}
            </div> */}
          </div>
        </div>

        {/* Navigation Data */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">
            Dữ liệu điều hướng
          </h3>

          <div className="space-y-4">
            <div>
              <label className={classLabel}>Chọn route *</label>
              <Select
                value={selectedRouteKey || undefined}
                onChange={(value) => {
                  setSelectedRouteKey(value);
                  updateNavigationFields(value, routeId);
                }}
                className="w-full"
                placeholder="Chọn route điều hướng"
              >
                <Select.OptGroup label="Mặc định">
                  {routeOptions
                    .filter((r) => !r.requiresId)
                    .map((r) => (
                      <Select.Option key={r.key} value={r.key}>
                        {r.label}
                      </Select.Option>
                    ))}
                </Select.OptGroup>
                <Select.OptGroup label="---------------------------------------------------">
                  {routeOptions
                    .filter((r) => r.requiresId)
                    .map((r) => (
                      <Select.Option key={r.key} value={r.key}>
                        {r.label}
                      </Select.Option>
                    ))}
                </Select.OptGroup>
              </Select>
            </div>

            {(() => {
              const opt = routeOptions.find((r) => r.key === selectedRouteKey);
              if (opt?.requiresId) {
                return (
                  <div>
                    <label className={classLabel}>ID tham số *</label>
                    <input
                      type="text"
                      value={routeId}
                      onChange={(e) => {
                        const v = e.target.value;
                        setRouteId(v);
                        updateNavigationFields(selectedRouteKey, v);
                      }}
                      className={`${classInput} ${
                        !routeId ? "border-red-500" : ""
                      }`}
                      placeholder="Nhập id"
                    />
                  </div>
                );
              }
              return null;
            })()}

            <div>
              <label className={classLabel}>Navigation *</label>
              <input
                readOnly
                type="text"
                value={formData.data.navigation}
                className={`${classInput} ${
                  errors["data.navigation"] ? "border-red-500" : ""
                } bg-gray-100 text-gray-500 cursor-not-allowed`}
                placeholder="phototime://<Route>"
              />
              {errors["data.navigation"] && (
                <div className={classError}>{errors["data.navigation"]}</div>
              )}
            </div>

            <div>
              <label className={classLabel}>Navigate *</label>
              <input
                readOnly
                type="text"
                value={formData.data.navigate}
                className={`${classInput} ${
                  errors["data.navigate"] ? "border-red-500" : ""
                } bg-gray-100 text-gray-500 cursor-not-allowed`}
                placeholder="phototime://<Route>"
              />
              {errors["data.navigate"] && (
                <div className={classError}>{errors["data.navigate"]}</div>
              )}
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-center">
          <button
            type="submit"
            disabled={loading}
            className="px-8 py-3 bg-[pink] text-white rounded-md hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-semibold"
          >
            {loading ? "Đang gửi..." : "Gửi thông báo"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NotificationPage;
